/* eslint-disable no-unused-expressions */
/* eslint-disable radix */
import { Box, Button, FormControl, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'
import React, { useState , useEffect } from 'react'
import { AccessAlarm, CheckCircleOutlineOutlined, HighlightOff, StarsRounded } from '@material-ui/icons'
import { dinamicTablesStyles } from './styles'
import HeaderFiltersTable from './HeaderFiltersTable'



const TableActionsAreas = ({ info, groupData }) => {
  // const [manager, setManager] = useState('todas')
  // const [boss, setBoss] = useState('todas')
  // const [selectedActions, setSelectedActions] = useState('todas')
  const classes = dinamicTablesStyles()

  const [filteredInfo, setFilteredInfo] = useState(groupData(info, 'razon_social'))
  const managers = filteredInfo.map(partner => partner[0].gerente)
  const bosses = filteredInfo.map(partner => partner[0].jefe)
  const areas = [
    'Cartera',
    'Jurídica Mobility',
    'Impulsa',
    'Posventa y garantías',
    'Trade',
    'Comercial',
    'MICE',
    'Socio'
  ]
  const addActions = (array) => {
    const total = array.reduce((a, b) => parseInt(a) + parseInt(b), 0)
    return total
  }
  // const filterArray = () => {}
  // const handleChange = (e, type) => {
  //   type === 'manager' ? setManager(e.target.value) : setBoss(e.target.value)
  //   filterArray(type, e.target.value)
  // };

  const updateValues = () => {
    setFilteredInfo(groupData(info, 'razon_social'))
  }
  useEffect(() => {
    updateValues()
  },[info])
  return (
    <Box className={classes.container}>
      <h3 className={classes.title}>Acciones de socios por área</h3>
      <HeaderFiltersTable managers={managers} bosses={bosses}/>
      <TableContainer className={classes.tableContainer}>
        <Table>
          <TableHead className={classes.head}>
            <TableRow className={classes.rowHead}>
              <TableCell>Gerente</TableCell>
              <TableCell>Jefe</TableCell>
              <TableCell>Socio</TableCell>
              {areas.map(area => (
                <TableCell align='center'>{area}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className={classes.body}>
            {filteredInfo.map(partner => (
              <TableRow>
                <TableCell>{partner[0].gerente}</TableCell>
                <TableCell>{partner[0].jefe}</TableCell>
                <TableCell>{partner[0].razon_social}</TableCell>
                {areas.map(area => (
                  <TableCell align='center'>{addActions(partner.filter(action => action.area === area).map(action => action.total))}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default TableActionsAreas